import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'src/store';
import { ArtistAdapter } from './artist.adapter';

export const artistSelect = (state: RootState) => state.features.artists.artist;

export const artistSelectors = ArtistAdapter.getSelectors();

export const selectArtist = createSelector(
    artistSelect,
    (state) => artistSelectors.selectAll(state)[0]
);
